var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class CasinoPlayerActivity {
    constructor(app, inactivityLogoutMinutes, connection) {
        this.isChecked = false;
        this.resetChecked = () => {
            this.isChecked = false;
        };
        if (app.IsNativeApp()) {
            this.platform = "native";
        }
        else if (app.deviceType.isDesktop()) {
            this.platform = "desktop";
        }
        else {
            this.platform = "mobile";
        }
        this.configuration = {
            inactivityLogoutMinutes
        };
        this.connection = connection;
    }
    onLastBetInfoReceived(lastBetAge) {
        let leftActivityInterval = this.configuration.inactivityLogoutMinutes * 60 - lastBetAge;
        let isActive = leftActivityInterval > 0;
        if (isActive) {
            this.isChecked = true;
            setTimeout(this.resetChecked, leftActivityInterval * 1000);
            return true;
        }
        else {
            return false;
        }
    }
    ;
    checkActivity() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isChecked) {
                return true;
            }
            else {
                let lastBetAge = yield this.connection.getLastBetAge(this.platform);
                return this.onLastBetInfoReceived(lastBetAge);
            }
        });
    }
}
;
;
//# sourceMappingURL=CasinoPlayerActivity.js.map